<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            size="mini" type="info" icon="el-icon-printer"
            style="margin-left: 1px;"
            @click="handlerPrint"
          >打印</el-button>
          <el-button
            size="mini" type="warning" icon="el-icon-delete-solid"
            style="margin-left: 1px;"
            @click="handlerClear"
          >清空</el-button>
          <el-button
            size="mini" type="primary" icon="el-icon-delete-solid"
            style="margin-left: 1px;"
            @click="loadData"
          >查询</el-button>
          <el-select size="mini" v-model="queryData.productName" filterable placeholder="选择样本册" style="width: 200px;margin-left:20px" @change="handlerProductChange">
            <el-option v-for="item in products" :key="item.sampleName" :label="item.sampleName" :value="item.sampleName"></el-option>
          </el-select>
          <el-select size="mini" v-model="queryData.pageCode" multiple placeholder="页码" filterable clearable style="width: 200px;margin-left:20px" @change="handlerPageChange">
            <el-option v-for="item in pageCodes" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
          <el-select size="mini" v-model="queryData.designation" multiple placeholder="品番" filterable clearable style="width: 200px;margin-left:20px">
            <el-option v-for="(item, index) in designations" :key="index" :label="item.merchandiseNumber" :value="item.merchandiseNumber"></el-option>
          </el-select>
          <el-select size="mini" v-model="queryData.fenqi" multiple placeholder="分期" filterable clearable style="width: 200px;margin-left:20px">
            <el-option v-for="(item, index) in fenqiDatas" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="库位"
            prop="dict_value"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="品番"
            prop="merchandiseNumber"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="分期"
            align="center"
            width="120">
            <template slot-scope="scope">
              <label v-if="scope.row.fristBack === '0'">前期</label>
              <label v-if="scope.row.fristBack === '1'">中期</label>
              <label v-if="scope.row.fristBack === '2'">后期</label>
              <label v-if="scope.row.fristBack === '3'">无限制</label>
            </template>
          </el-table-column>
          <el-table-column
            label="页码"
            prop="pageCount"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="样本册"
            prop="sampleName"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="单位1"
            prop="bagNum"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="单位2"
            prop="packageNum"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="包装产量"
            prop="productOutput"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="笼号"
            prop="basketNo"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="担当"
            prop="undertake"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <div id="print_area" style="position: relative; z-index: -1; text-align:center; ">
      <table
        border="1px solid #000"
        cellspacing="0"
        style="table-layout: fixed"
      >
        <thead>
          <tr>
            <th style="width:50px">序号</th>
            <th style="width:200px">品名</th>
            <th style="width:70px">页码</th>
            <th style="width:70px">品番</th>
            <th style="width:70px">包数</th>
            <th style="width:70px">每包数</th>
            <th style="width:70px">总数</th>
            <th style="width:70px">笼号</th>
            <th style="width:70px">库位</th>
          </tr>
        </thead>
        <tr v-for="(itemSub, indexSub) in dsPrint" :key="indexSub">
          <td style="text-align: center;">{{ indexSub + 1 }}</td>
          <td style="text-align: center;">{{ itemSub.sampleName }}</td>
          <td style="text-align: center;">{{ itemSub.pageCount }}</td>
          <td style="text-align: center;">{{ itemSub.merchandiseNumber }}</td>
          <td style="text-align: center;">{{ itemSub.bagNum }}</td>
          <td style="text-align: center;">{{ itemSub.packageNum }}</td>
          <td style="text-align: center;">{{ itemSub.productOutput }}</td>
          <td style="text-align: center;">{{ itemSub.basketNo }}</td>
          <td style="text-align: center;">{{ itemSub.locationNo }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data: function() {
    return {
      ds: [],
      queryData: {
        productName:"",
        pageCode:[],
        designation: [],
        fenqi:[],
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0, // 数据总条数
        isAll:false,//是否查询全部数据（不分页）
      },
      dsPrint:[],//打印数据集合
      products: [],
      pageCodes: [],
      designations: [],
      fenqiDatas:[{label:'前期',value:'0'},{label:'中期',value:'1'},{label:'后期',value:'2'},{label:'无限制',value:'3'}]
    };
  },
  created: function() {},
  mounted: function() {
    this.loadProductData();
  },
  methods: {
    // 加载样本册数据
    loadProductData: function () {
      const _this = this
      _this.post(_this.$apis.getStoreProducts, {}, function (res) {
        const _json = res.data
        _this.products = _json.products
      })
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.queryData.isAll=false;
      if (!_this.queryData.productName) {
        _this.$message({
          type: 'error',
          message: '查询时样品名称不能为空！'
        })
        return false
      }
      _this.post(_this.$apis.getTwoFloorList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    handlerClear: function () {
      this.queryData = {
        productName: '',
        // 页码
        pageCode: [],
        // 番号
        designation: [],
        // 分期
        fenqi: [],
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0, // 数据总条数
        isAll:false,//是否查询全部数据（不分页）
      }
      this.ds = [];
      this.pageCodes = []
      this.designations = []
      this.dsPrint=[]
    },
    handlerProductChange: function () {
      const _this = this
      // ajax提交至服务器，删除数据
      _this.post(_this.$apis.getStorePageCodes, this.queryData, function (res) {
        let _json = res.data
        _this.pageCodes = _json.pageCodes
        _this.designations = _json.designations
      })
    },
    handlerPageChange: function (val) {
      const _this = this
      _this.queryData.designation = []
      _this.designations = []
      if(_this.queryData.pageCode != '') {
        // ajax提交至服务器，删除数据
        _this.post(_this.$apis.getDesignations, this.queryData, function (res) {
          let _json = res.data
          _this.designations = _json.designations
        })
      }
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    },
    // 打印
    handlerPrint: function () {
      let _this = this;
      if (!_this.queryData.productName) {
        _this.$message({
          type: 'error',
          message: '打印时样品名称不能为空！'
        })
        return false
      }
      _this.queryData.isAll=true;
      _this.dsPrint=[]
      _this.post(_this.$apis.getTwoFloorList, _this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.dsPrint = _json.datalist;
          _this.$nextTick(() => {
            const style =
            '@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
            _this.$print({
              printable: 'print_area',
              type: 'html',
              style: style,
              scanStyles: false
            })
          })

        }
      });
    }
  },
  components: {}
};
</script>
